import { render, staticRenderFns } from "./ChartOrderFulfillmentStats.vue?vue&type=template&id=ef709e2c"
import script from "./ChartOrderFulfillmentStats.vue?vue&type=script&lang=js"
export * from "./ChartOrderFulfillmentStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports